import axios from 'axios'
import appBridge from 'libs/appBridge'

const errorHandle = (errorData, status, message) => {
  switch (status) {
    case 400:
      console.error(message)
      break
    case 401:
      console.error(message)
      break
    case 404:
      console.error(message)
      break
    case 500:
      console.error(message)
      break
    case 503:
      console.error(message)
      break
    default:
      console.error(`Unexpected error:${status}`)
  }
}

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
})

instance.interceptors.request.use(
  async (config) => {
    const sessionToken = await appBridge.client.getSessionToken()

    config.headers = {
      ['x-shopline-session-token']: sessionToken,
    }

    return config
  },
  (error) => Promise.reject(error),
)

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error
    const { data } = response || {}
    const { message } = data
    if (response) {
      errorHandle(data, response.status, message)
    }
    return Promise.reject(error)
  },
)

export default instance
export const apiGetRequest = ({ url, config }) => instance.get(url, config)
export const apiPostRequest = ({ url, data, config }) => instance.post(url, data, config)
export const apiPatchRequest = ({ url, data, config }) => instance.patch(url, data, config)
export const apiPutRequest = ({ url, data, config }) => instance.put(url, data, config)
